import { Badge, Card } from '@components'
import type { Component } from 'solid-js'
import { css, cx } from 'styled-system/css'
import { Flex } from 'styled-system/jsx'
import { aspectRatio } from 'styled-system/patterns'

type ImageCardProps = {
	image: {
		title: string
		src?: string
	}
	onClick?: () => void
}

export const Image: Component<ImageCardProps> = (props) => {
	return (
		<Card.Root
			onClick={props.onClick}
			style={{
				'background-image': props.image.src ? `url(${props.image.src})` : undefined,
			}}
			class={cx(
				aspectRatio({ ratio: 16 / 9 }),
				css({
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					width: '100%',
					cursor: props.onClick ? 'pointer' : 'default',
				}),
			)}
		>
			<Flex alignItems="end!important">
				<Badge
          variant='subtle'
          size='sm'
					mb={2}
					position="absolute"
				>
					{props.image.title}
				</Badge>
			</Flex>
		</Card.Root>
	)
}
